@use "../../../globals/bcp";

bcp-activity-indicator {
  @keyframes rotating-activity-indicator-animation {
    0% {
      transform: perspective(120px) rotateX(0deg) rotateY(0deg);
    }

    25% {
      transform: perspective(120px) rotateX(-180deg) rotateY(0deg);
    }

    50% {
      transform: perspective(120px) rotateX(-180deg) rotateY(-180deg);
    }

    75% {
      transform: perspective(120px) rotateX(-360deg) rotateY(-180deg);
    }

    100% {
      transform: perspective(120px) rotateX(-360deg) rotateY(-360deg);
    }
  }

  .rotating-activity-indicator-container {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: hsla(0deg 0% 100% / 1);
  }

  .rotating-activity-indicator-plane {
    position: relative;
    width: 40px;
    height: 40px;
    margin: 100px 0;
    animation: rotating-activity-indicator-animation 2s infinite ease-in-out;
  }

  .buderus-activity-indicator-icon-background-color {
    fill: #002d5a;
  }

  .buderus-activity-indicator-icon-color {
    fill: #fff;
  }

  .vulcano-activity-indicator-icon-color {
    fill: #be002c;
  }

  .a-activity-indicator {
    margin-left: -22px;
    margin-top: -22px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: block;
    animation: loading-animation-scale 10s infinite ease-in-out;

    &__background {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 3;
      background: rgba(255 255 255 / 1);
    }

    .A-loaderIndicator__el {
      display: none;
    }
  }
}

@include bcp.theme("ivt") {
  .a-activity-indicator__bottom-box {
    background-color: bcp.colorVar("link-text") !important;
  }

  .a-activity-indicator__top-box {
    background-color: bcp.colorVar("text") !important;
  }
}
